const autoCorrectPhrase = (text: string) => {
  if (!text || typeof text !== 'string') return '';

  // Curățăm spațiile în exces
  text = text.trim().replace(/\s+/g, ' ');

  // Adăugăm punct la final dacă nu există deja
  // Nu adăugăm punct dacă textul se termină deja cu . sau alte semne de punctuație sau ghilimele
  if (
    !text.endsWith('.') &&
    !text.endsWith('!') &&
    !text.endsWith('?') &&
    !text.endsWith('"') &&
    !text.endsWith("'") &&
    !text.endsWith('”')
  ) {
    text += '.';
  }

  // Transformăm prima literă în majusculă
  text = text.charAt(0).toUpperCase() + text.slice(1);

  // După fiecare . ? ! urmat de spațiu + literă mică → facem literă mare
  text = text.replace(/([.!?]\s*)([a-zăâîșț])/g, (match, sep, letter) => {
    return sep + letter.toUpperCase();
  });

  return text;
};

export { autoCorrectPhrase };
